var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[(_vm.icon)?_c('i',{staticClass:"icon-container",domProps:{"innerHTML":_vm._s(_vm.icons[_vm.icon])}}):_vm._e(),_c('div',{staticClass:"typography"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }